import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import TreeSearchSelect from "../TreeSearchSelect";
import { get } from "../../../controlers/global/ConfigRequest";
import { COMPANY_BUSINESS_TYPE_TREE } from "../../../helperData/ApiAddress";
import { selectedBusinessTypeIds } from "../../../pages/profile/companyProfilePayload";

export default function BusinessTypeSelect({
    value,
    onChange,
    placeholder,
    className,
    hint,
}) {
    const { t, i18n } = useTranslation();
    const [tree, setTree] = useState([]);

    useEffect(() => {
        get(COMPANY_BUSINESS_TYPE_TREE, { language: i18n.language || "fa" })
            .then((data) => setTree(Array.isArray(data) ? data : []))
            .catch(() => setTree([]));
    }, [i18n.language]);

    return (
        <>
            <TreeSearchSelect
                data={tree}
                multiple
                className={className || "business-type-select"}
                placeholder={
                    placeholder ||
                    t("Organizational.Profile.BusinessType.placeholder")
                }
                value={selectedBusinessTypeIds({ business_types: value })}
                onChange={onChange}
            />
            {hint ? <p className="field-hint">{hint}</p> : null}
        </>
    );
}
